import { DFLError } from '@dfl/react-security';

export const usePaymentMapError = (error: DFLError) => {
  if (!error) return null;
  if (error?.networkError) return error;
  return error;
};
